/**
 * CancelFeesScreen — adaptateur primaire de la route `cancel-fees` (étape 3/5).
 *
 * Fil : l'aperçu des frais + le view-model qui l'écrit, l'état qui porte les deux sorties. Le
 * bandeau du bas remplace la boîte de dialogue « Erreur » du legacy : un échec serveur s'accuse,
 * il ne se répond pas.
 */
import React from "react"
import { useSelector } from "react-redux"

import { CancelFeesPage, Snackbar } from "../../../../../../design-system"
import { cancelFeesViewModel } from "../../../../view-models/parent/SubscriptionCancel/cancelFeesViewModel"
import { type CancelFlowScreenProps } from "./cancelFlowNavigation"
import { useCancelFeesData } from "./useCancelFeesData"
import { useCancelFeesState } from "./useCancelFeesState"

export function CancelFeesScreen(props: CancelFlowScreenProps) {
    const routeParams = props.route?.params ?? {}
    const data = useCancelFeesData()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vm = useSelector((state: any) => cancelFeesViewModel(state, data.raw))
    const state = useCancelFeesState({
        routeParams,
        preview: data.raw,
        hasFees: vm.fees?.hasFees === true,
        calendlySubject: vm.calendlySubject,
    })

    return (
        <>
            <CancelFeesPage
                fees={vm.fees}
                loading={data.loading}
                error={vm.error}
                onRetry={data.retry}
                onBookAppointment={state.actions.onBookAppointment}
                onContinue={state.actions.onContinue}
                submitting={state.submitting}
                confirmVisible={state.confirmVisible}
                confirmMessage={state.confirmMessage}
                onConfirm={state.actions.onConfirm}
                onCancelConfirm={state.actions.onCancelConfirm}
                onBack={state.actions.onBack}
                onClose={state.actions.onClose}
            />
            <Snackbar
                visible={state.feedback != null}
                message={state.feedback ?? ""}
                tone="danger"
                onDismiss={state.actions.onCloseFeedback}
            />
        </>
    )
}

export default CancelFeesScreen
